import { Icon } from '@design-system';
import { getCurrencySymbolByCode } from '@utils/locations';
import { useTranslation } from 'next-i18next';
import React, { useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { FooterLocaleVisibilityContext } from '../../../context/FooterLocaleVisibilityContext';
import { useCountryCode } from '../../../hooks/useCountryCode';
import { useCurrency } from '../../../hooks/useCurrency';
import { useUnitOfMeasurement } from '../../../hooks/useUnitOfMeasurement';
import EmbeddedContainer from '../../Containers/DrawerContainer/EmbeddedContainer';
import Drawer from '../Drawer';
import { LocaleForm } from './LocaleForm';

const FooterLocale: React.FC = () => {
  const { t: countryTranslation } = useTranslation('countries');
  const { t: footerTranslation } = useTranslation('footer');
  const [currency] = useCurrency();
  const [unit] = useUnitOfMeasurement();
  const [countryCode] = useCountryCode();
  const { hide, show, shown } = useContext(FooterLocaleVisibilityContext);

  const form = useForm({
    defaultValues: {
      countryCode,
      currency,
      unitOfMeasurement: unit,
    },
  });

  useEffect(
    () =>
      form.reset({
        countryCode,
        currency,
        unitOfMeasurement: unit,
      }),
    [currency, unit, countryCode],
  );

  function handleClose() {
    form.reset();
    hide();
  }

  return (
    <>
      <button
        className="link flex items-center space-x-1"
        onClick={() => show('footer')}
        type="button"
      >
        <Icon name="ic_language" />
        <span>
          {`${countryTranslation(
            countryCode,
          )} (${currency} ${getCurrencySymbolByCode(currency)})`}
          <span aria-hidden="true">{' ∙ '}</span>
          {unit.toLowerCase()}
        </span>
      </button>

      <Drawer
        onClose={handleClose}
        overlayOtherDrawers
        shown={shown}
        title={footerTranslation('drawers.locale.title')}
      >
        <EmbeddedContainer embedded>
          <LocaleForm form={form} hideForm={handleClose} />
        </EmbeddedContainer>
      </Drawer>
    </>
  );
};

export default FooterLocale;
